const reducer = (state, action) => {
	switch (action.type) {
		case 'UPDATE_LOADED':
			return {
				...state,
				loaded: action.payload,
			};
		default:
			return state;
	}
};

export default reducer;
